import { WechatLayout } from './components/WechatLayout';

/**
 * 微信管理页面入口
 */
export default function WechatPage() {
  return <WechatLayout />;
}
